import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ViewDetails from './ViewDetails';



// Lazy load components
const AddUser = lazy(() => import('./AddUser'));
const ViewUser = lazy(() => import('./ViewUser'));

const UserManagmntModule = () => {
  return (
    <Suspense fallback={null}>
       <Routes>
        <Route path="addUser" element={<AddUser />} />
        <Route path="ViewUser" element={<ViewUser />} />
        <Route path="ViewDetails" element={<ViewDetails />} />
      </Routes>
    </Suspense>
  );
};

export default UserManagmntModule;
